import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  style: {"width":"100%","height":"100%"},
  class: "overflow-auto px-16px pt-16px pb-16px"
}
const _hoisted_2 = { class: "search flex items-center gap-4px mb-10px]" }
const _hoisted_3 = {
  key: 0,
  class: "imageList-wrap mb-[24px]"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "elementList-wrap"
}

import { ref, reactive, computed, onMounted, nextTick } from 'vue';
import { ElInput, ElButton, ElCascader, ElIcon } from 'element-plus'
import { ArrowDown, Search, ArrowLeft, ArrowRight } from '@element-plus/icons-vue'
import { getMaterialsPages } from '@/api/affairs'
import recommendSection from './recommendSection.vue'
//@ts-ignore
import elementlist from './elementlist.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'image',
  setup(__props) {

const menuList = ref([])
const searchValue = ref('')
//@ts-ignore
const listRef = ref<HTMLElement | null>(null)
const canScrollLeft = ref(false)
const canScrollRight = ref(false)
const elementShow = ref(false)
const elementlistRef = ref<typeof elementlist>()
onMounted(() => {
  getMaterialsPages({ page: 1, size: 50, type: '2' }).then(res => {
    menuList.value = res.data.data.items
    updateScrollState()
  })
})

const updateScrollState = () => {
  const el = listRef.value
  if (!el) return
  canScrollLeft.value = el.scrollLeft > 0
  canScrollRight.value = el.scrollLeft + el.clientWidth < el.scrollWidth
}

const onScroll = () => updateScrollState()
const scrollLeft = () => listRef.value?.scrollBy({ left: -200, behavior: 'smooth' })
const scrollRight = () => listRef.value?.scrollBy({ left: 200, behavior: 'smooth' })
const categoryopt = ref('')
const handleCategorySelect = (e: any) => {
  categoryopt.value = e
  console.log(e)
  elementShow.value = true
}

const handleSearch = () => {
  categoryopt.value = ''
  elementShow.value = false
  nextTick(() => {
    if (!searchValue.value) {
      return
    }
    elementShow.value = true
    nextTick(() => {
      elementlistRef.value?.pagesearch(searchValue.value)
    })
  })

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElInput), {
        modelValue: searchValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        placeholder: "请输入搜索内容",
        clearable: "",
        "prefix-icon": _unref(Search),
        style: {"margin-right":"16px"},
        onClear: _cache[1] || (_cache[1] = ($event: any) => (elementShow.value = false))
      }, null, 8, ["modelValue", "prefix-icon"]),
      _createVNode(_unref(ElButton), {
        type: "primary",
        onClick: handleSearch,
        style: {"background-color":"#2a66ff"}
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("搜索", -1)
        ]))]),
        _: 1
      })
    ]),
    (!elementShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (canScrollLeft.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "lefticon",
                onClick: scrollLeft
              }, [
                _createVNode(_unref(ElIcon), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowLeft))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (menuList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "imageList",
                ref_key: "listRef",
                ref: listRef,
                onScroll: onScroll
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "menu-items",
                    onClick: ($event: any) => (handleCategorySelect(item))
                  }, _toDisplayString(item.name), 9, _hoisted_4))
                }), 128))
              ], 544))
            : _createCommentVNode("", true),
          (canScrollRight.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "righticon",
                onClick: scrollRight
              }, [
                _createVNode(_unref(ElIcon), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowRight))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!elementShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(recommendSection, {
            onMore: _cache[2] || (_cache[2] = ($event: any) => (handleCategorySelect($event)))
          })
        ]))
      : _createCommentVNode("", true),
    (elementShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(elementlist, {
            category: categoryopt.value,
            onBack: _cache[3] || (_cache[3] = ($event: any) => (elementShow.value = false)),
            ref_key: "elementlistRef",
            ref: elementlistRef
          }, null, 8, ["category"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})